import { __read } from "tslib";
import { getMonth, getYear } from 'date-fns';
import React, { useMemo, useRef, useState } from 'react';
import { CaretDown24, CaretUp24, ChevronDown24, ChevronLeft32, ChevronRight32, } from '@carbon/icons-react';
import cx from 'classnames';
import { twMerge } from 'tailwind-merge';
var VisibleYearsInList = 5;
var monthListClassName = 'justify-self-center self-center items-center grid grid-rows-6 gap-[1px]';
var montListButtonClassName = function (selected) {
    return twMerge("block border border-transparent w-[45px] text-center py-[1px] px-[3px] cursor-pointer rounded-default\n        hover:border-hover-grey hover:bg-hover-grey", selected &&
        'bg-cerulean-20 border-cerulean-default hover:bg-cerulean-20 hover:border-cerulean-default');
};
var yearPickerListButtonClassName = function (selected, hoverStyle) {
    return twMerge("block border border-transparent w-fit-content align-center py-[1px] px-[3px] justify-self-center rounded-default", hoverStyle && 'hover:border-hover-grey hover:bg-hover-grey', selected && 'bg-cerulean-20 border-cerulean-default');
};
var createMonthList = function (locale) {
    var _a;
    var monthList = [];
    for (var i = 0; i < 12; i++) {
        var monthMethod = (_a = locale.localize) === null || _a === void 0 ? void 0 : _a.month;
        if (monthMethod) {
            monthList.push(monthMethod(i, { width: 'abbreviated' }));
        }
    }
    return monthList;
};
var createYearList = function (currentYear, yearListOffset) {
    var yearList = [];
    for (var i = 0; i < VisibleYearsInList; i++) {
        yearList.push(currentYear + yearListOffset + i);
    }
    return yearList;
};
export var MonthYearPicker = function (_a) {
    var locale = _a.locale, calendarDate = _a.calendarDate, nextMonth = _a.nextMonth, nextMonthDisabled = _a.nextMonthDisabled, prevMonth = _a.prevMonth, prevMonthDisabled = _a.prevMonthDisabled, setDifferentMonth = _a.setDifferentMonth, setDifferentYear = _a.setDifferentYear;
    var monthYearPickerRef = useRef(null);
    var _b = __read(useState(false), 2), isMonthYearPickerVisible = _b[0], setMonthYearPickerVisibility = _b[1];
    var _c = __read(useState(0), 2), yearListOffset = _c[0], setYearListOffset = _c[1];
    var adjustYearOffset = function (event) {
        event.stopPropagation();
        var value = event.currentTarget.value;
        if (value) {
            setYearListOffset(function (currentOffset) { return currentOffset + Number(value); });
        }
    };
    var toggleMonthYearPicker = function () {
        return setMonthYearPickerVisibility(function (currentVisibilityState) {
            if (currentVisibilityState) {
                setYearListOffset(0);
            }
            return !currentVisibilityState;
        });
    };
    var setYearFromPicker = function (event) {
        event.stopPropagation();
        setDifferentYear(+event.currentTarget.value);
        setMonthYearPickerVisibility(false);
        setYearListOffset(0);
    };
    var setMonthFromPicker = function (event) {
        event.stopPropagation();
        setDifferentMonth(+event.currentTarget.value);
        setMonthYearPickerVisibility(false);
        setYearListOffset(0);
    };
    var monthList = useMemo(function () { return createMonthList(locale); }, [locale]);
    var yearList = useMemo(function () { return createYearList(getYear(calendarDate), yearListOffset); }, [calendarDate, yearListOffset]);
    return (React.createElement("div", { className: "flex justify-between items-center relative", ref: monthYearPickerRef },
        React.createElement("button", { type: "button", onClick: prevMonth, className: cx(prevMonthDisabled && 'text-alto'), disabled: prevMonthDisabled },
            React.createElement(ChevronLeft32, null)),
        React.createElement("button", { type: "button", className: cx('flex border border-alto rounded-default py-[6px] px-[12px] cursor-pointer'), onClick: toggleMonthYearPicker },
            locale.localize.month(getMonth(calendarDate)),
            ' ',
            getYear(calendarDate),
            ' ',
            React.createElement(ChevronDown24, { className: cx('text-mirage') })),
        React.createElement("button", { type: "button", onClick: nextMonth, className: cx(nextMonthDisabled && 'text-alto'), disabled: nextMonthDisabled },
            React.createElement(ChevronRight32, null)),
        isMonthYearPickerVisible && (React.createElement("div", { className: "absolute top-10 w-60 left-2/4 -translate-x-2/4 h-[220px] border border-alto rounded-default\n                shadow-[0px_1px_4px_0px_#72727226] bg-white grid grid-cols-[2fr_1fr]" },
            React.createElement("div", { className: "grid grid-cols-2" },
                React.createElement("div", { className: monthListClassName }, monthList.slice(0, 6).map(function (month, index) { return (React.createElement("button", { "aria-label": month, type: "button", className: cx('text-caption', montListButtonClassName(getMonth(calendarDate) === index)), key: month, value: index, onClick: setMonthFromPicker }, month)); })),
                React.createElement("div", { className: twMerge(monthListClassName, 'justify-self-start') }, monthList
                    .slice(6, monthList.length)
                    .map(function (month, index) { return (React.createElement("button", { type: "button", "aria-label": month, className: cx('text-caption', montListButtonClassName(getMonth(calendarDate) ===
                        index + 6)), key: month, value: index + 6, onClick: setMonthFromPicker }, month)); }))),
            React.createElement("div", { className: "grid grid-cols-1" },
                React.createElement("div", { className: "w-full grid grid-rows-[repeat(7,1fr)] gap-[1px]" },
                    React.createElement("button", { type: "button", value: -1, onClick: adjustYearOffset, className: yearPickerListButtonClassName(false, false) },
                        React.createElement(CaretUp24, { "data-value": -1 })),
                    yearList.map(function (year) { return (React.createElement("button", { type: "button", "aria-label": year.toString(), className: cx('text-caption', yearPickerListButtonClassName(getYear(calendarDate) === year, true)), key: year, value: year, onClick: setYearFromPicker }, year)); }),
                    React.createElement("button", { type: "button", value: 1, onClick: adjustYearOffset, className: yearPickerListButtonClassName(false, false) },
                        React.createElement(CaretDown24, { "data-value": 1 }))))))));
};
